import axios, { AxiosResponse } from "axios";
import { PermissionSchemeTable } from "./types";

export const createNewPermissionScheme = async (
    payload: Pick<PermissionSchemeTable, 'name' | 'priceInEuro'>
): Promise<AxiosResponse<void>> => {
    return axios.post(`/api/taxonomies/permissionSchemes/create`, payload);
}

export const toggleReflectPermissionSchemeDetails = async (
    id: string,
    payload: Pick<Pick<PermissionSchemeTable, 'name' | 'priceInEuro'>,
        | "name"
        | "priceInEuro"
    >
): Promise<AxiosResponse<Pick<PermissionSchemeTable, 'name' | 'priceInEuro'>>> => {
    return axios.post(`/api/taxonomies/permissionSchemes/${id}/update`, payload);
}

export const togglePermissionScheme = async (
    id: string,
    state: boolean
): Promise<AxiosResponse<void>> => {
    return axios.post(`/api/taxonomies/permissionSchemes/${id}/${state ? "activate" : "deactivate"}`);
}